import { createSlice } from "@reduxjs/toolkit";
import { cleanPayload } from "../../utils/utilityfunctions";

const initialState = {
  shape: [],
  color: [],
  carat: [],
  minCarat: 0,
  maxCarat: 0,
  minPrice: 0,
  maxPrice: 0,
  lab: [],
  clarity: [],
  cut: [],
  polish: [],
  symmetry: [],
  minDepthPercentage: 0,
  maxDepthPercentage: 0,
  minTablePercentage: 0,
  maxTablePercentage: 0,
  fluorescent: [],
  culet: [],
  stockNumber: "",
  // girdle: [],
  location: "",
  // fancyColor: [],
  minRatio: 0,
  maxRatio: 0,
  certificateNumber: "",

  filterToApply: {
    pageNumber: 1,
    pageSize: 20,
  },
};

export const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    updateFilter: (state, action) => {
      const { key, value, subTypes } = action.payload;
      if (Array.isArray(state[key])) {
        if (!state[key].includes(value)) {
          if (subTypes) {
            subTypes.forEach((item) => {
              state[key].push(item);
            });
          } else {
            state[key].push(value);
          }
        }
      } else {
        state[key] = value;
      }
    },
    removeFromFilter: (state, action) => {
      const { key, value, subTypes } = action.payload;

      if (Array.isArray(state[key])) {
        state[key] = state[key].filter((item) =>
          subTypes ? !subTypes?.includes(item) : item !== value
        );
      } else {
        state[key] = "";
      }
    },
    addFilterToApply: (state, action) => {
      state.filterToApply = cleanPayload(action.payload);
    },
    resetFilterState: (sate, action) => {
      return initialState;
    },
  },
});

export const {
  updateFilter,
  removeFromFilter,
  addFilterToApply,
  resetFilterState,
} = filterSlice.actions;
export default filterSlice.reducer;
